window.DealTypes ?= {}

DealTypes.View = Backbone.View.extend
  events:
    'click a': '_toggle'

  initialize: ->
    @model.on 'change:value', => @_updateClass()

  #############
  ## PRIVATE ##
  #############

  _toggle: (e) ->
    e?.preventDefault()
    @model.toggle()
    @model.save()

  _updateClass: ->
    if @model.get('value') == 'positive'
      @$('a').addClass 'matching'
    else
      @$('a').removeClass 'matching'


module.exports = DealTypes.View
